// @flow

import * as React from 'react';

type Props = {
  /** Children nodes to render. */
  children: React.Node,
  /**
   * Custom link component to be used wherever a `<Link>` is used in the
   * Design System. Can be used to hook up `<Link>`'s to a custom routing
   * solution. Defaults to an `<a>` tag if none is provided.
   **/
  LinkComponent: *,
};

const defaultContext = {
  LinkComponent: 'a',
};

const DesignSystemContext = React.createContext(defaultContext);

export const useDesignSystem = () => React.useContext(DesignSystemContext);

/**
 * Allows consumers to configure various details of the Design System. This
 * should be used at the root of your application.
 */
const DesignSystemProvider = ({ children, LinkComponent }: Props) => {
  return children ? (
    <DesignSystemContext.Provider value={{ LinkComponent }}>
      {React.Children.only(children)}
    </DesignSystemContext.Provider>
  ) : null;
};

export default DesignSystemProvider;
